//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import * as UserPreferenceClientLib from "../../../libs/client/UserPreference.client.js";

//
// Component
//

export function initialiseExperimentSettingsForm(experimentSettingsForm: HTMLElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(experimentSettingsForm, "apiUrl");

	experimentSettingsForm.addEventListener("submit",
		(event) =>
		{
			event.preventDefault();
		});

	const experimentalLwsAjaxInput = experimentSettingsForm.querySelector<HTMLInputElement>(`input[name="experimental::lws_pjax"]`);

	experimentalLwsAjaxInput?.addEventListener("change", 
		async () =>
		{
			await UserPreferenceClientLib.updateValue(apiUrl, experimentalLwsAjaxInput, "experimental::lws_pjax", experimentalLwsAjaxInput.checked);

			// TODO: Enable/disable PJAX immediately here, instead of waiting for the page to reload.
			window.location.reload();
		});
}

export function initialiseExperimentSettingsForms()
{
	const experimentSettingsForms = document.querySelectorAll<HTMLFormElement>(".component-experiment-settings-form");

	console.log("[ExperimentSettingsForm] Initialising " + experimentSettingsForms.length + " instances...");

	for (const experimentSettingsForm of experimentSettingsForms)
	{
		try
		{
			initialiseExperimentSettingsForm(experimentSettingsForm);
		}
		catch (error)
		{
			console.error("[ExperimentSettingsForm] Error initialising:", experimentSettingsForm, error);
		}
	}
}